import React from 'react';

import Tooltip from 'components/TooltipComponent';
import styles from './DownloadTemplate.css';

class DownloadTemplate extends React.Component {
  constructor(props) {
    super(props);
    this._tooltipWithDots = Tooltip({ totalStep: 4 });
  }

  render() {
    const { currentStep, handleDownload } = this.props;

    if (currentStep !== 1) {
      return null;
    }
    return (
      <div className={styles['container-content']}>
        <h4>
          Download <i>Import Recipes</i> Template
        </h4>
        <p>
          Click <i> Download Template </i> to get file (CSV file format). The
          template must be filled according to tutorial bellow. Doing the
          opposite might cause errors.
        </p>
        <button
          className={`${styles['button-download']} btn btn-primary`}
          onClick={() => handleDownload('example')}
          download
        >
          Download Template
        </button>
        <p>
          To get the tutorial on how to fill the recipe correctly,
          <a
            className={styles['button-download-link']}
            onClick={() => handleDownload('tutorial')}
            download
          >
            click here
          </a>
        </p>
      </div>
    );
  }
}

export default DownloadTemplate;
